import React from "react";
import styled from "styled-components";
import theme from "../../styles/theme";

const EloRatingChangeStyled = styled.span`
  color: ${({ change }) => {
    if (change > 0) return theme.colors.resultsGreen;
    if (change < 0) return theme.colors.resultsRed;
    return theme.colors.grey;
  }};
`;

const EloRatingChange = ({ change }) => {
  return (
    <EloRatingChangeStyled change={change}>
      {change >= 0 ? "+" : ""}
      {change}
    </EloRatingChangeStyled>
  );
};

export default EloRatingChange;
